export type SyncReachability = 'unknown' | 'reachable' | 'unreachable'
export type ConnectivityState = 'online' | 'offline_like'
export type ConnectivityReason = 'browser_offline' | 'sync_unreachable' | 'sync_unconfirmed'

export type ConnectivityInput = {
  browserOnline: boolean
  syncReachability: SyncReachability
}

export type ConnectivityResolution = {
  state: ConnectivityState
  isOfflineLike: boolean
  reason?: ConnectivityReason
  browserOnline: boolean
  syncReachability: SyncReachability
}

// Cloud connectivity is an overlay axis: browser offline or sync reachability failure
// both map to the same offline-like runtime contract.
export function resolveConnectivity(input: ConnectivityInput): ConnectivityResolution {
  if (!input.browserOnline) {
    return {
      state: 'offline_like',
      isOfflineLike: true,
      reason: 'browser_offline',
      browserOnline: input.browserOnline,
      syncReachability: input.syncReachability
    }
  }

  if (input.syncReachability === 'unreachable') {
    return {
      state: 'offline_like',
      isOfflineLike: true,
      reason: 'sync_unreachable',
      browserOnline: input.browserOnline,
      syncReachability: input.syncReachability
    }
  }

  if (input.syncReachability === 'unknown') {
    return {
      state: 'offline_like',
      isOfflineLike: true,
      reason: 'sync_unconfirmed',
      browserOnline: input.browserOnline,
      syncReachability: input.syncReachability
    }
  }

  return {
    state: 'online',
    isOfflineLike: false,
    browserOnline: input.browserOnline,
    syncReachability: input.syncReachability
  }
}
